export const emailExpression = /^[a-z0-9.!#$%&'*+\-/=?^_`{|}~]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

export function validateEmail(email: string): boolean {
  return email.length > 0 && emailExpression.test(email);
}
